const carouselConfigXA3 = {
    carousel: {
        PAYMENT: 'Ask me anything',
        SERVICE_PROBLEMS: 'Service problems?',
        PODS: 'All things Xfinity'

    }
}

export default carouselConfigXA3;